import { LanguageType } from '@/interface/enum';
import { getLangFromCookie } from '@/libraries/i18n';
import { getDevice } from '@/libraries/utils/userAgent';

interface SurveyToolParameters {
    isAsi: boolean;
    countryCode: string;
    customerInfo: { trackingId: string, isoCurrency: string };
}

export function setupSurveyTool({ isAsi, countryCode, customerInfo }: SurveyToolParameters) {
    const device = getDevice();
    const resolution = `${Math.floor(window.screen.width * window.devicePixelRatio)}x${Math.floor(window.screen.height * window.devicePixelRatio)}`;
    window._sva = window._sva || {};
    (function (opts) {
        opts.traits = {
            uuid: isAsi ? customerInfo?.trackingId : 'BSI',
            device_model: `${device.vendor} ${device.model}/${resolution}`,
            country: countryCode,
            currency: isAsi ? customerInfo?.isoCurrency : 'BSI',
            product: 'Sport',
            language: languageMapping(getLangFromCookie()),
        };
    }(window._sva));
}

function languageMapping(languageType: LanguageType) {
    const mapping: Partial<Record<LanguageType, string>> = {
        [LanguageType.EN]: 'en-US',
        [LanguageType.ID_ID]: 'id-ID',
        [LanguageType.TH_TH]: 'th-TH',
        [LanguageType.VI_VN]: 'vi-VN',
        [LanguageType.ZH_CN]: 'zh-CN',
        [LanguageType.KO_KR]: 'ko-KR',
        [LanguageType.JA_JP]: 'ja-JP',
        [LanguageType.MY_MM]: 'my-MM',
        [LanguageType.PT_BR]: 'pt-BR',
        [LanguageType.KM_KH]: 'km-KH',
        [LanguageType.BN_BD]: 'bn-BD',
        [LanguageType.MS_MY]: 'ms-MY',

    };

    return mapping[languageType] ?? 'en-US';
}
